import {useContext, useEffect, useState} from "react";
import {Context} from "../component/context";
import {Get} from "component/const/Get";
import {filter} from "component/const/Functions.js";
import {ListTable} from "../component/ListTable";

export const TestCreate = ()=>{
    const {search} = useContext(Context);
    const [data, setData] = useState(null)
    useEffect(() => {
        Get('list_test_create')
            .then(data => filter(data, search))
            .then(data=>setData(data))
            .catch(e=>alert(e));
    }, []);
    useEffect(() => {
        setData(filter(data, search))
    }, [search]);
    return <ListTable data={data}/>
}